export interface PlanAdminRow {
    id: string;
    hideOnEE: boolean;
    receiveEmail: boolean;
    sendGroupPAEmail: boolean;
    sendIndividualPAEmail: boolean;
    showCustomCatReport: boolean;
    twoFactorEnabled: boolean;
    isTrained: boolean;
    readOnly: boolean;
    role: string | null;
}

export type PaType = "group" | "individual";

export type PaTypeSelection = PaType | "none";

export function paTypeOf(
    row: Pick<PlanAdminRow, "sendGroupPAEmail" | "sendIndividualPAEmail">
): PaTypeSelection {
    if (row.sendGroupPAEmail) {
        return "group";
    }

    if (row.sendIndividualPAEmail) {
        return "individual";
    }

    return "none";
}

export function paTypeFlags(
    selection: PaTypeSelection
): { sendGroupPAEmail: boolean; sendIndividualPAEmail: boolean } {
    return {
        sendGroupPAEmail: selection === "group",
        sendIndividualPAEmail: selection === "individual",
    };
}
